<script setup lang="ts">
import { Countries } from '../../shared/libraries/countries';
</script>

<template>
  <div
    class="px-3 flex h-full items-center ripple"
    @click="
      $bus.emit($constants.EVENTS.TRANSACTIONS.DETAILS_REQUESTED, $attrs.item)
    "
  >
    <!-- {{ $attrs.item }} -->
    <div class="flex md:grid grid-cols-3 gap-2 items-center w-full">
      <div class="col-span-1 flex gap-2 items-center">
        <div class="w-18 h-18 rounded-full bg-white p-2 shimmerTarget relative">
          <ImgComponent
            :src="$attrs.item?.logo"
            alt=""
            class="w-full h-full rounded-full"
          />
          <div
            class="w-7 h-7 absolute bottom-0 right-0 rounded-full p-1 shimmerTarget"
            :class="{
              'bg-[#27BE43]': $attrs.item?.operation == 'fund',
              'bg-[#FF4F6C]': $attrs.item?.operation == 'withdraw'
            }"
          >
            <ColorImg
              src="/images/all/arrow-up.svg"
              alt=""
              :class="{
                'rotate-30': $attrs.item?.operation == 'fund',
                'rotate-210': $attrs.item?.operation == 'withdraw'
              }"
              class="w-full h-full rounded-full bg-white"
            />
          </div>
        </div>
        <div class="overflow-x-hidden whitespace-nowrap">
          <div class="text-lg shimmerTarget min-w-24 truncate w-full">
            {{ $attrs.item?.senderFirstName }}&nbsp;{{
              $attrs.item?.senderLastName
            }}
          </div>
          <div
            class="description-color shimmerTarget min-w-32 mt-0.5 text-sm hidden md:block"
          >
            {{
              Countries.find($attrs.item?.senderCountryCode)?.countryName
            }}
            &nbsp; {{ $attrs.item?.senderEmail }} &nbsp;
          </div>
          <div class="text-lg shimmerTarget min-w-24 truncate w-full md:hidden">
            {{ $attrs.item?.operationNameDisplay }} &nbsp;
          </div>
          <div
            class="description-color shimmerTarget min-w-32 mt-0.5 text-sm md:hidden"
          >
            {{ $attrs.item?.startDate }} &nbsp;
          </div>
        </div>
      </div>
      <div class="overflow-x-hidden whitespace-nowrap hidden md:flex">
        <div class="text-lg shimmerTarget min-w-24 truncate w-full">
          {{ $attrs.item?.operationNameDisplay }} &nbsp;
        </div>
        <div
          class="description-color shimmerTarget min-w-32 w-full mt-0.5 text-sm"
        >
          {{ $attrs.item?.startDate }} &nbsp;
        </div>
      </div>
      <div class="ml-auto text-end items-end flex flex-col">
        <div
          class="min-w-16 shimmerTarget text-lg"
          :class="{
            'text-[#27BE43]': $attrs.item?.operation == 'fund',
            'text-[#FF4F6C]': $attrs.item?.operation == 'withdraw'
          }"
        >
          {{
            $attrs.item?.operation == 'fund'
              ? '+'
              : $attrs.item?.operation == 'withdraw'
                ? '-'
                : ''
          }}
          {{ $attrs.item?.amountToReceive }}
          CFA &nbsp;
        </div>
        <div class="mt-0.5 min-w-16 shimmerTarget whitespace-nowrap">
          &nbsp;{{ $attrs.item?.statusDisplay }}
        </div>
      </div>
    </div>
  </div>
</template>
